import React from 'react';
import '../styles/About.css';
import { PageHeader } from '../components';

const About: React.FC = () => {
  return (
    <div className="about">
      <PageHeader title="About Us" />
      <div className="about-container">
        
        
        <div className="about-content">
          <section className="about-section">
            <h2>Trusted Partner in Total Water Management</h2>
            <p>
              With over 25 years of experience, Wasser Technochem (I) Ltd. (WTIL) has grown into one of India's leading companies in industrial water and wastewater treatment. We are proud to be ISO 9001:2015 and ISO 45001:2018 certified and registered as an MSME enterprise, underscoring our commitment to quality, safety, and innovation.
            </p>
            <p>
              WTIL holds the distinction of being Rajasthan's first water treatment company, established with the goal of addressing water challenges for industries in the region. We were also the first to introduce organized Operation & Maintenance (O&M) services for large textile houses and cement plants in the state — a pioneering move that continues to set us apart.
            </p>
            <p>
              We specialize in end-to-end water treatment solutions, ranging from chemical supply and design consultancy to large-scale project execution and long-term service contracts. Our mission is to help industries in India optimize water usage, reduce environmental impact, and ensure long-term regulatory compliance.
            </p>
          </section>
          
          <section className="about-section">
            <h2>Our Expertise</h2>
            <div className="services-grid">
              <div className="service-item">
                <h3>Chemical Supply</h3>
                <p>Comprehensive range of water treatment chemicals for various industrial applications and processes.</p>
              </div>
              <div className="service-item">
                <h3>Design Consultancy</h3>
                <p>Expert consultation and design services for optimal water treatment system planning and implementation.</p>
              </div>
              <div className="service-item">
                <h3>Project Execution</h3>
                <p>Large-scale water treatment project execution with proven track record across multiple industries.</p>
              </div>
              <div className="service-item">
                <h3>O&M Services</h3>
                <p>Comprehensive Operation & Maintenance services ensuring optimal performance and regulatory compliance.</p>
              </div>
            </div>
          </section>
          
          <section className="about-section">
            <h2>Why Choose WTIL</h2>
            <ul className="benefits-list">
              <li>25+ years of proven experience in water treatment</li>
              <li>ISO 9001:2015 and ISO 45001:2018 certified</li>
              <li>Rajasthan's first water treatment company</li>
              <li>Pioneer in organized O&M services</li>
              <li>End-to-end water treatment solutions</li>
              <li>MSME registered enterprise</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
